const getBaseSize = (): number => {
  const sizeString: string[] = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue('font-size')
    .match(/\d+/) ?? [''];
  return +sizeString[0] || 16;
};

export const fontSize = (size: number) => `${size / getBaseSize()}rem`;
